module.exports = __webpack_public_path__ + "img/ax.c47c0af8.png";